import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { CtaBand } from './CtaBand';
import { CarrierShip, Spot } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { BOARD } from './ProductBiddingPage.data';
import { NextLink, ProductFaq, ProductHero, ProductSection } from './ProductParts';
import './product-bidding.css';
function Step({ k, title, text, children }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "mk-pb-step",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "mk-pb-step__k",
                children: k
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: "mk-pb-step__title",
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mk-pb-step__text",
                children: text
            }),
            children
        ]
    });
}
// Product tour 05. Design: design-mockups/rhd-woodblock/Product-Bidding.dc.html.
export default function ProductBiddingPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('bidding'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    stack: true,
                    k: "入札",
                    label: "Product · 05 Bidding & wins",
                    title: "Watch, bid, won. One tap each, one record per car.",
                    lead: "Every lot you act on becomes a car record. It follows the car from your watchlist to sold, and every stage sits on one page.",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "mk-pb-board",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "mk-pb-board__grid",
                            children: BOARD.map((c)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pb-col",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-pb-col__head",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: `mk-pb-pill mk-pb-pill--${c.tone}`,
                                                    children: c.name
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-pb-col__count",
                                                    children: c.count
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mk-pb-col__cars",
                                            children: c.cars.map((car)=>/*#__PURE__*/ _jsxs("div", {
                                                    className: "mk-pb-car",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("b", {
                                                            className: "mk-pb-car__name",
                                                            children: car.n
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-pb-car__meta",
                                                            children: car.m
                                                        })
                                                    ]
                                                }, car.n))
                                        })
                                    ]
                                }, c.name))
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 300,
                    children: /*#__PURE__*/ _jsx(CarrierShip, {})
                }),
                /*#__PURE__*/ _jsx(ProductSection, {
                    title: "The car record starts the first time you tap.",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-pb-steps",
                        children: [
                            /*#__PURE__*/ _jsx(Step, {
                                k: "壱",
                                title: "Watch",
                                text: "Tap watch on any result. That starts a new car record with the lot, its sheet read and the price guide.",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "mk-pb-ui mk-pb-chip-btn",
                                    children: "☆ Watch"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Step, {
                                k: "弐",
                                title: "Bid",
                                text: "Record your bid next to the suggested range, then place it with your agent as usual. The app never bids for you.",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "mk-pb-ui mk-pb-chip-btn mk-pb-chip-btn--bid",
                                    children: "Bid ¥1,340,000"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Step, {
                                k: "参",
                                title: "Result check",
                                text: "Once the auction’s over, the app checks the result and asks you to confirm. One tap marks it won.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pb-ui mk-pb-check",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-pb-check__title",
                                            children: "Probably won · ¥1,280,000"
                                        }),
                                        /*#__PURE__*/ _jsxs("span", {
                                            className: "mk-pb-check__btns",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-pb-check__btn mk-pb-check__btn--ok",
                                                    children: "Confirm win"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-pb-check__btn",
                                                    children: "Not right"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Step, {
                                k: "四",
                                title: "Won elsewhere? Add it by link",
                                text: "Won a car outside the app? Paste the lot’s link and the app pulls it in, already marked won.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pb-ui mk-pb-add",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-pb-add__input",
                                            children: "jdmauc.net/aj-50316…"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-pb-add__btn",
                                            children: "Add"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    tightTop: true,
                    title: "Bidding questions",
                    items: [
                        [
                            'What are the stages?',
                            'Watching, Bidding, Won, Importing and In stock, then Sold once you record the sale. Lost and passed lots stay on file, and you can reopen them.'
                        ],
                        [
                            'What if the result check is wrong?',
                            'It can’t mark a car won by itself. Every result waits for you to confirm or reject it.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next · 06",
                    title: "Landed cost",
                    go: "原価 →",
                    href: MKT.product('landed-cost')
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
